export { SuggestedContentCard } from './SuggestedContentCard'
